/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Description_Export_Control_Track_FailedInputs */



/**
* | output |
* | --- |
* | "AD control track export failed. {error}" |
*
* @param {Audio_Description_Export_Control_Track_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_control_track_failed = /** @type {((inputs: Audio_Description_Export_Control_Track_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Control_Track_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l'export de la piste de contrôle AD. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Export der AD-Steuerspur fehlgeschlagen. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione della traccia di controllo AD non riuscita. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось экспортировать управляющую дорожку АД. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al exportar la pista de control de AD. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`AD 控制音轨导出失败。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`AD コントロールトラックの書き出しに失敗しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`AD कंट्रोल ट्रैक निर्यात विफल रहा। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao exportar a faixa de controlo de AD. ${i?.error}`)
	return /** @type {LocalizedString} */ (`AD control track export failed. ${i?.error}`)
});